import { useAppSelector } from "../../framework/redux/hooks";
import { calendarDaySelectors } from "../../framework/redux/slices/calendarSlice";

export const useSelectCalendarDay = (day: string) => {
    const state = useAppSelector((state) => state.calendar);
    return calendarDaySelectors.selectById(state, day);
};